<div
  class="dynamic-icon"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.color]="color"
  [innerHTML]="sanitizedSvg">
</div>
